<template>
  <div :class="['nav-sub',store&&'nav-sub-store',st&&'fixed']">
    <div :class="['nav-sub-wrapper', 'w',store&&'nav-sub-store-wrapper',st&&'fixed']">
      <div class="nav-list1" v-if="!store">
        <div class="title" @click.stop.self.prevent="toGoodsList">
          所有分类
          <div class="cate-pop-div">
            <ul class="cate-pop1 cate-pop" @mouseleave="handleMouseleaveUl">
              <template v-for="(item, index) in cateList">
                <li :key="item.category_name" @mouseenter="handleMouseenterLi(index)">
                  <div class="cate-pop-lv1">
                    <a @click.stop="selCate(1,item)" class="cate-pop-lv1-text">
                      {{item.category_name}}
                    </a>
                    <div class="cate-pop-lv2">
                      <div class="cate-pop-lv2-text" v-for="(childItem, childIndex) in item.children" :key="childIndex">
                        <a @click.stop="selCate(2,childItem,item)">{{childItem.category_name}}</a>
                      </div>
                    </div>
                  </div>

                  <div v-show="index === subCateIndex" class="sub-cate">
                    <div class="item" v-for="(childItem, childIndex) in item.children" :key="childIndex">
                      <a @click.stop="selCate(2,childItem,item)">{{childItem.category_name}}</a>
                      <div class="menu-2-line">|</div>
                      <div
                        v-if="childItem.children"
                        v-for="v in childItem.children"
                        :key="v.category_name"
                        @click.stop="selCate(3,childItem,item,v)"
                        class="menu-2"
                      >
                        <a class="">{{v.category_name}}</a>
                      </div>
                    </div>
                  </div>
                  <div v-if="index > 8 || index + 1 != cateList.length" class="cate-pop-line"></div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <ul class="nav-list2">
        <li @click="change(-2)" :class="[store&&'primary-color']" v-if="store">店铺首页</li>
        <li @click="change(-1)">全部商品</li>
        <li v-for="v in data" @click="change(v)">{{v.tab}}</li>
      </ul>
      <div class="searchbar-small" v-if="store">
        <el-input v-model="searchVal" @keyup.enter.native="onEnterSearch"></el-input>
        <span class="iconfont icon-search" @click="onEnterSearch"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["cateList", "usage", "data", "st"],
  data() {
    return {
      searchVal: "",

      subCateIndex: -1,
    };
  },
  computed: {
    store() {
      return this.usage === "store";
    }
  },
  methods: {
    change(params) {
      this.$emit("change", params);
    },
    selCate(position, item, parentItem, grandChild) {
      let dom = document.getElementsByClassName('cate-pop1')[0]
      console.log("selCate");
      this.$emit("selCate", position, item, parentItem, grandChild);
      dom.style.display = 'none'
      setTimeout(() => {
        dom.style = {}
      }, 0);
    },
    toGoodsList() {
      console.log("toGoodsList");
      window.open("//" + window.location.host + "/#/goods");
    },
    // 搜索框 获取值
    onEnterSearch(e) {
      this.$emit("search", this.searchVal);
      console.log("search: " + this.searchVal);
    },

    handleMouseleaveUl() {
      this.subCateIndex = -1
    },

    handleMouseenterLi(index) {
      this.subCateIndex = index
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/theme";
.nav-sub {
  position: relative;
  z-index: 20;
  height: 70px;
  // background: #282724;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  // border-bottom: 2px solid #E60012;
  &-store {
    background: #fff;
    &-wrapper {
      display: flex;
      justify-content: space-between;
    }
  }
  &.fixed {
    position: fixed;
    z-index: 21;
    height: 60px;
    top: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid #dadada;
    background-image: -webkit-linear-gradient(#fff, #f1f1f1);
    background-image: linear-gradient(#fff, #f1f1f1);
    .nav-list1 .title:hover .cate-pop {
      display: none;
    }
    .nav-list1 {
      color: #666;
      .title {
        line-height: 59px;
      }
    }
    .nav-list2 {
      color: #666;
      li {
        line-height: 59px;
      }
    }
  }
  .nav-sub-wrapper {
    // padding: 31px 0;
    height: 40px;
    padding-top: 30px;
    box-sizing: initial;
    position: relative;
    &.fixed {
      padding: 0;
      height: 100%;
      display: flex;
      align-items: center;
      .nav-list1 {
        background: transparent;
        color: #E60012;
        .cate-pop {
          color: #fff;
        }
      }
    }
    &:after {
      content: " ";
      position: absolute;
      top: 89px;
      left: 50%;
      margin-left: -610px;
      width: 1220px;
      // background: #000;
      height: 1px;
      display: none;
      opacity: 0;
      -webkit-transition: opacity 0.3s ease-in;
      transition: opacity 0.3s ease-in;
    }
  }
  .w {
    display: flex;
  }
  .nav-list1 {
    position: relative;
    text-align: center;
    width: 170px;
    height: 100%;
    display: flex;
    align-items: center;
    height: 100%;
    .title {
      width: 100%;
      text-align: left;
      line-height: 40px;
      padding-left: 15px;
      height: 100%;
      &:hover {
        transition: 0.3s;
        background: #222;
        color: #fff;
        .cate-pop {
          display: block;
        }
      }
    }
  }
  .nav-list2 {
    width: 1020px;
    height: 100%;
    line-height: 40px;
    // overflow-x: scroll;
    // overflow-y:hidden;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    li:first-child {
      margin-left: 30px;
    }
    li {
      float: left;
      padding: 0 20px;
      &.active {
        font-weight: bold;
      }
      &:hover {
        cursor: pointer;
        color: #E60012;
      }
    }
    // li:before {
    //   content: ' ';
    //   position: absolute;
    //   left: 0;
    //   top: 13px;
    //   width: 2px;
    //   height: 2px;
    //   background: #bdbdbd;
    // }
  }
}
.primary-color {
  color: #E60012;
}
.searchbar-small {
  // float: right;
  display: flex;
  margin-right: 10px;
  height: 40px;
  .icon {
    top: 12px;
  }
  .el-input {
    height: 30px;
    margin: 5px;
  }

  .icon-search {
    line-height: 40px;
    cursor: pointer;
    &:hover {
      color: #E60012;
    }
  }
}
.cate-pop{
  div.menu-2{
    a{
      color: #505050;
      font-weight:400!important;
      font-size: 12px!important;
    }
  }
  div.menu-2-line{
    color: #222;
    padding: 0;
  }
  .cate-pop-line{
    width: 140px;
    height: 1px;
    background: #ddd;
    margin: 10px auto 0 auto;
  }
}
.cate-pop-lv1{
  &-text{
    padding-left: 15px;
    font-weight: bold;
    margin-top: 8px;
    display: block;
  }
}
.cate-pop-lv2{
  display: flex;
  flex-wrap: wrap;
  width: 150px;
  margin: auto;
  font-size: 12px;
  line-height: 30px;
  &-text{
    padding: 0 5px;
  }
}
.cate-pop-none{
  display: none;
}
</style>
<style lang="scss">
@import "../../assets/style/theme";
.nav-sub .el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #E60012;
  outline: 0;
}
.nav-sub .el-input__inner {
  height: 30px;
  line-height: 30px;
}
</style>




// WEBPACK FOOTER //
// nav.vue?7e7cb6a7